export default __webpack_public_path__ + "static/media/Ballroll_00096.0bb043e7.png";